import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut } from "../../api/index";
import { urlAllConceptProtected, urlConceptProtected } from "../../api/urls";
import { PAGE_SIZE_10 } from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.snapshotUuid !== undefined)
      filter += "&snapshotUuid=" + filters.snapshotUuid;
    // if (filters.showError !== undefined && filters.status === undefined)
    //   filter += "&showError=" + filters.showError;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

export const getConcept = createAction("GET_CONCEPT_PART_BY_UUID", (param) =>
  apiGet(urlConceptProtected, param, true)()
);

export const putConcept = createAction("PUT_CONCEPT", (param, data) =>
  apiPut(urlConceptProtected, param, data, true)()
);

export const allConcept = createAction("ALL_CONCEPTS", (param) =>
  apiGet(urlAllConceptProtected, param, true)()
);
